import React, { Component } from 'react'
import { Link } from "react-router-dom"

import igLogo from 'static/images/instagram-logo.svg'
import fbLogo from 'static/images/facebook-logo.svg'
import darkGreen from 'static/images/dark-green.svg'

class GreenFooter extends Component {
	render() {
		return (
			<footer>
                <div className="container-fluid" style={{ backgroundColor: '#47c0bb'}}>
                    <div className="container">
                        <div className="row footer">
                            <div className="col-sm-4 col-12">
                                <div className="row align-content-between" style={{ height: '100%' }}>
                                    <div className="col-12 text-sm-left text-center"><img src={darkGreen} /></div>
                                    <div className="col-12 text-sm-left text-center social-icon">
                                        <a href="https://www.instagram.com/cellwineapp/" target="_blank"><img src={igLogo} style={{ marginRight: '12px' }} /></a>
                                        <a href="https://www.facebook.com/CellWineAppTW/" target="_blank"><img src={fbLogo} style={{ marginRight: '12px' }} /></a>
                                    </div>
                                </div>

                            </div>
                            <div className="col-sm-2 col-12 block">
                                <p className="title text-sm-left text-center">CELLWINE</p>
                                <div className="text-sm-left text-center" style={{ marginBottom: '12px' }}>
                                    <Link to="faq">常見問題</Link>
                                </div>
                                <div className="text-sm-left text-center" style={{ marginBottom: '12px' }}>
                                    <Link to="price-detail">收費標準</Link>
                                </div>
                                <div className="text-sm-left text-center" style={{ marginBottom: '12px' }}>
                                    <Link to="terms-of-use">條款及細則</Link>
                                </div>
                                <div className="text-sm-left text-center">
                                    <a href="https://cell.wine" target="_blank">CELLWINE 官網</a>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12 block">
                                <p className="title text-sm-left text-center">總公司</p>
                                <p className="text-sm-left text-center" style={{ marginBottom: '12px', fontWeight: '300' }}>台北市大安區新生南路二段2號B1</p>
                                <p className="text-sm-left text-center" style={{ marginBottom: '12px', fontWeight: '300' }}>02-23222885</p>
                            </div>
                            <div className="col-sm-2 col-12 block">
                                <p className="title text-sm-left text-center">服務時間</p>
                                <p className="text-sm-left text-center" style={{ marginBottom: '12px', fontWeight: '300' }}>週一～週五 10am-6pm</p>
                                <p className="text-sm-left text-center" style={{ marginBottom: '12px', fontWeight: '300' }}>*國定假日休息</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
		)
	}
}

export default GreenFooter
